// on login page
export const AUTH_LOGIN_REQUEST = 'auth/AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'auth/AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'auth/AUTH_LOGIN_FAILURE';
export const AUTH_LOGIN_RESET = 'auth/AUTH_LOGIN_RESET';
// on navbar logout button
export const AUTH_LOGOUT = 'auth/AUTH_LOGOUT_SUCCESS';

// on signup page
export const AUTH_REGISTER_REQUEST = 'auth/AUTH_REGISTER_REQUEST';
export const AUTH_REGISTER_SUCCESS = 'auth/AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'auth/AUTH_REGISTER_FAILURE';
export const AUTH_REGISTER_RESET = 'auth/AUTH_REGISTER_RESET';